export default {
  BILLING: 'gtm-billing',
  TRASH_POST: 'gtm-trash-post',
};
